import { PlayerStreamStatus, Webcast } from '@graphql/gql/graphql';

/**
 * Return Webcast object with new stream status, keep all the other fields intact
 * @param {Webcast} webcast
 * @param {PlayerStreamStatus} streamStatus
 */
const getUpdatedWebcastStreamStatus = (webcast: Webcast, streamStatus: PlayerStreamStatus): Webcast => {
  if (!webcast) {
    return null;
  }

  return {
    ...webcast,
    player: {
      ...webcast?.player,
      stream: {
        ...webcast?.player?.stream,
        status: streamStatus
      }
    }
  };
};

export { getUpdatedWebcastStreamStatus };
